module.exports = __webpack_public_path__ + "zw.svg?b06a95075d9f2e96282b9fac5f3a287f";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/zw.svg
// module id = 1175
// module chunks = 27